import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Library, ClipboardCheck, FileSignature, Check } from 'lucide-react';
const bonuses = [{
  icon: <Library className="w-7 h-7" data-id="element-40" />,
  n: 'Bono #1',
  title: 'Biblioteca Premium de 100 Modelos Editables',
  items: ['Reclamos administrativos.', 'Presentaciones ante organismos de consumo.', 'Acuerdos conciliatorios.', 'Demandas judiciales.', 'Recursos procesales.', 'Medidas cautelares.', 'Presentaciones complementarias.'],
  value: 'AR$ 9.990'
}, {
  icon: <ClipboardCheck className="w-7 h-7" data-id="element-41" />,
  n: 'Bono #2',
  title: 'Sistema Express de Evaluación de Casos',
  items: ['Checklist de viabilidad.', 'Entrevista inicial al cliente.', 'Matriz de análisis jurídico.', 'Cuadro de daños reclamables.', 'Hoja de ruta procesal.', 'Planilla de seguimiento.'],
  value: 'AR$ 7.990'
}, {
  icon: <FileSignature className="w-7 h-7" data-id="element-42" />,
  n: 'Bono #3',
  title: 'Kit Profesional de Cartas Documento',
  items: ['Intimación por incumplimiento contractual.', 'Reclamo por producto defectuoso.', 'Reclamo por falta de entrega.', 'Reclamo por facturación indebida.', 'Reclamos bancarios y financieros.', 'Solicitud de baja de servicios.', 'Intimaciones a aseguradoras.'],
  value: 'AR$ 18.500'
}];
export const Bonuses = () => {
  return <section className="py-12 bg-legal-900" data-id="element-43">
      <div className="container mx-auto px-4" data-id="element-44">
        <div className="text-center mb-10 max-w-2xl mx-auto" data-id="element-45">
          <span className="inline-flex items-center gap-2 text-gold-500 font-semibold tracking-widest uppercase text-sm mb-4" data-id="element-46">
            <Gift className="w-4 h-4" data-id="element-47" />
            Bonos GRATIS incluidos
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-48">
            🎁 Bonos GRATIS incluidos
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-49">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="relative bg-legal-800 border border-gold-500/30 rounded-xl p-7 flex flex-col hover:border-gold-500/60 transition-colors" data-id="element-50">
              <span className="absolute -top-3 left-6 bg-gold-500 text-legal-900 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-51">
                {bonus.n}
              </span>

              <div className="mb-5 mt-2 flex items-center justify-center w-14 h-14 rounded-lg bg-gold-500/10 text-gold-500" data-id="element-52">
                {bonus.icon}
              </div>

              <h3 className="text-lg font-bold text-white mb-4 leading-snug" data-id="element-53">
                {bonus.title}
              </h3>

              <ul className="space-y-2 mb-6 flex-1" data-id="element-54">
                {bonus.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-slate-300" data-id="element-55">
                    <Check className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-56" />
                    {item}
                  </li>)}
              </ul>

              <div className="flex items-center justify-between border-t border-legal-700 pt-4" data-id="element-57">
                <span className="text-sm text-slate-400" data-id="element-58">
                  Valor:{' '}
                  <span className="line-through decoration-gold-500/70 decoration-2 text-slate-400" data-id="element-59">
                    {bonus.value}
                  </span>
                </span>
                <span className="font-bold text-gold-500 uppercase tracking-wide text-sm" data-id="element-60">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};